module.exports = __webpack_public_path__ + "img/6a1fcc0.png";